module.exports = __webpack_public_path__ + "static/media/07.a5282bc4.png";